import myHttp from './myHttp';
import store from '../vuex/store'

const getBusinessList = params => {
    return myHttp.post(store.state.api+'/business/list', params);
};

const getRegaddQrcode = params => {
    return myHttp.post(store.state.api+'/user/regadd/qrcode', params);
};

const businessRegist = params => {
    return myHttp.post(store.state.api+'/business/register/account', params);
};

const getBusinessInfo = params => {
    return myHttp.post(store.state.api+'/business/get', params);
};

const getUseRecordList = params => {
    return myHttp.post(store.state.api+'/business/record/used', params);
};

const getBuyRecordList = params => {
    return myHttp.post(store.state.api+'/business/record/purchase', params);
};

const businessTransfer = params => {
    return myHttp.post(store.state.api+'/trade/checkout/transfer', params);
};

const revokeTransfer = params => {
    return myHttp.post(store.state.api+'/trade/transfer/revoke', params);
};

const getTransferList = params => {
    return myHttp.post(store.state.api+'/trade/transfer/list', params);
};

const getBusinessPurchaserRecordList = params => {
    return myHttp.post(store.state.api+'/trade/purchase/list', params);
};

const getUserInfo = params => {
    return myHttp.post(store.state.api+'/user/profile/get', params);
};

const editUserNickName = params => {
    return myHttp.post(store.state.api+'/user/profile/update', params);
};

const getUsedTrend = params => {
    return myHttp.post(store.state.api+'/home/stats/used/trend', params);
};

const bindPhoneNumber = params => {
    return myHttp.post(store.state.api+'/user/phone/add', params);
};



// const getUserList = params => { return axios.get(`${base}/user/list`, { params: params }); };
//
// const getUserListPage = params => { return axios.get(`${base}/user/listpage`, { params: params }); };
//
// const removeUser = params => { return axios.get(`${base}/user/remove`, { params: params }); };
//
// const batchRemoveUser = params => { return axios.get(`${base}/user/batchremove`, { params: params }); };
//
// const editUser = params => { return axios.get(`${base}/user/edit`, { params: params }); };
//
// const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };

export default {
    getBusinessList,
    businessRegist,
    getRegaddQrcode,
    getBusinessInfo,
    getUseRecordList,
    getBuyRecordList,
    getBusinessPurchaserRecordList,
    getUserInfo,
    editUserNickName,
    businessTransfer,
    revokeTransfer,
    getTransferList,
    getUsedTrend,
    bindPhoneNumber,
    // getUserList,
    // getUserListPage,
    // removeUser,
    // batchRemoveUser,
    // editUser,
    // addUser,
}



// WEBPACK FOOTER //
// ./src/api/api.js